import React from 'react'
import MuiMenuItem from '@mui/material/MenuItem'

const MenuItem = ({ children, ...restProps }) => {
  return <MuiMenuItem {...restProps}>{children}</MuiMenuItem>
}

export default MenuItem
